import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import '@/styles/about.css';

export const About = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <div className="about-container">
        <div className="about-content">
          <h4 className="gtitle about-title">
            <span className="gtitle-light">Qui sommes</span>
            <span className="gtitle-strong">nous ?</span>
          </h4>
          
          <div className="about-section">
            <p>
              Hémo-J est bien plus qu&apos;une marque de compléments alimentaires : c&apos;est une marketplace dédiée au bien-être global.
              Née d&apos;une conviction simple — prendre soin de soi ne doit jamais se faire au détriment de la nature — notre plateforme
              a pour vocation de rassembler le meilleur de la santé naturelle et de la parapharmacie.
            </p>
          </div>

          <div className="about-section">
            <h2>Une expertise, deux piliers</h2>
            <p>
              Au-delà de notre produit phare et de notre propre gamme de solutions médicales et nutritionnelles, Hémo-J ouvre ses
              portes à des partenaires rigoureusement sélectionnés.
            </p>
          </div>

          <div className="about-section">
            <h2>Notre engagement : la triple exigence</h2>
            <p>Qu&apos;il s&apos;agisse des produits signés Hémo-J ou de ceux de nos partenaires, notre sélection repose sur des standards stricts :</p>
            <ul className="values-list">
              <li>
                <strong>Qualité brute :</strong> Des ingrédients issus de circuits courts, choisis pour leur richesse nutritionnelle exceptionnelle.
              </li>
              <li>
                <strong>Pureté absolue :</strong> Des formulations sans additifs chimiques ni colorants, pour aller droit à l&apos;essentiel.
              </li>
              <li>
                <strong>Rigueur scientifique :</strong> Une démarche fondée sur la preuve, avec des contrôles et des validations qui garantissent une confiance totale.
              </li>
            </ul>
          </div>

          <div className="about-section">
            <h2>La transparence comme boussole</h2>
            <p>
              Chez Hémo-J, la transparence n&apos;est pas un argument marketing, c&apos;est une règle d&apos;or. Nous détaillons la composition de
              chaque produit, l&apos;origine des actifs et la raison de leur sélection. Notre ambition est de rendre à la nutrition sa pureté
              d&apos;origine, en mariant la force du végétal local aux exigences des standards médicaux les plus sérieux.
            </p>
          </div>

          <div className="about-section">
            <h2>Une approche responsable</h2>
            <p>
              Parce que chaque détail compte, nous privilégions une démarche éco-responsable, de la sélection des matières premières jusqu&apos;au
              choix des emballages. Hémo-J, c&apos;est la promesse d&apos;un catalogue de produits naturels, testés et traçables, pour nourrir le corps
              sans trahir la nature.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
